<form [formGroup]="form">
  <div class="row">
    <div class="col-12 col-md-6">
      <div class="form-group">
        <label>
          <span class="label-content">Company Name</span>
          <input class="form-control" type="text" name="companyName" maxlength="255" placeholder="..." formControlName="companyName" />
          <cx-form-errors [control]="form.get('companyName')"></cx-form-errors>
        </label>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="form-group">
        <label>
          <span class="label-content">Street Address</span>
          <input class="form-control" type="text" name="street" maxlength="255" placeholder="..." formControlName="street" />
          <cx-form-errors [control]="form.get('street')"></cx-form-errors>
        </label>
      </div>
    </div>

    <div class="col-12 col-md-4">
      @if (form.disabled) {
        <div class="form-group">
          <label>
            <span class="label-content">Country</span>
            <input class="form-control" type="text" name="country" maxlength="255" placeholder="" formControlName="country" />
            <cx-form-errors [control]="form.get('country')"></cx-form-errors>
          </label>
        </div>
      } @else {
        <countries-dropdown
          [disabled]="form.disabled"
          [isocode]="country?.isocode"
          [countries$]="countries$"
          (_onSelectCountry)="setCountry($event)"
          [form]="form"
        ></countries-dropdown>
      }

      <cx-form-errors [control]="form.get('country')"></cx-form-errors>
    </div>

    <div class="col-12 col-md-4">
      @if (form.disabled) {
        <div class="form-group">
          <label>
            <span class="label-content">State/Region</span>
            <input class="form-control" type="text" name="region" maxlength="255" placeholder="" formControlName="region" />
            <cx-form-errors [control]="form.get('region')"></cx-form-errors>
          </label>
        </div>
      } @else {
        <ng-container *ngIf="stateRegions$ | async as stateRegions">
          <div class="form-group">
            <label>
              <span class="label-content"> State/Region </span>

              <select class="form-control" formControlName="region">
                <option value="" disabled selected>{{ 'generic.selectAnOption' | cxTranslate }}</option>
                <option *ngFor="let item of stateRegions" [attr.aria-label]="item.label" value="{{ item.code }}">
                  {{ item.label }}
                </option>
              </select>

              <cx-form-errors [control]="form.get('region')"></cx-form-errors>
            </label>
          </div>
        </ng-container>
      }
    </div>

    <div class="col-12 col-md-4">
      <div class="form-group">
        <label>
          <span class="label-content">City</span>
          <input class="form-control" type="text" name="city" maxlength="255" placeholder="" formControlName="city" />
          <cx-form-errors [control]="form.get('city')"></cx-form-errors>
        </label>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="form-group">
        <label>
          <span class="label-content">Zip</span>
          <input class="form-control" type="text" name="zipCode" maxlength="10" placeholder="" formControlName="zipCode" />
          <cx-form-errors [control]="form.get('zipCode')"></cx-form-errors>
        </label>
      </div>
    </div>
  </div>
</form>
